"use strict";

exports.__esModule = true;
exports.transformSpecialtyIconUri = exports.getCorrectSpecialtyIcon = exports.getSpecialtyNameFromIconUri = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSpecialtyNameFromIconUri = exports.getSpecialtyNameFromIconUri = function getSpecialtyNameFromIconUri(iconUri) {
  var uriPattern = /specialty-icons\/(.+)\./i;
  var uriParts = uriPattern.exec(iconUri);
  return uriParts && uriParts[1];
};

var getCorrectSpecialtyIcon = exports.getCorrectSpecialtyIcon = function getCorrectSpecialtyIcon(specialty, iconDictionary) {
  if ((0, _keys2.default)(iconDictionary).includes(specialty)) {
    return iconDictionary[specialty];
  }

  return specialty;
};

var transformSpecialtyIconUri = exports.transformSpecialtyIconUri = function transformSpecialtyIconUri(iconUri, iconDictionary) {
  var specialty = getSpecialtyNameFromIconUri(iconUri);

  return getCorrectSpecialtyIcon(specialty, iconDictionary);
};


// WEBPACK FOOTER //
// ./components/specialty-svg-icon/lib/utils/utils.js